import { trustPoints } from "@/mocks/articles";

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
            About
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-4">
            What Is{" "}
            <span className="italic">Hipobuy</span> Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            Hipobuy Spreadsheet is a structured product discovery resource that helps
            shoppers quickly find popular products, compare options, and research
            before purchasing. Instead of spending hours searching across multiple
            platforms, users can explore organized categories, product recommendations,
            and buying guides — all in one place.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {[
            {
              title: "Save Research Time",
              desc: "Find products faster with organized databases and structured category navigation.",
              icon: "ri-time-line",
            },
            {
              title: "Discover Hidden Products",
              desc: "Explore items that are difficult to find manually across multiple shopping platforms.",
              icon: "ri-search-eye-line",
            },
            {
              title: "Compare Before Buying",
              desc: "Use detailed guides and comparison tables to make informed decisions.",
              icon: "ri-scales-line",
            },
            {
              title: "Shop Smarter",
              desc: "Make confident purchasing decisions with verified product information and community insights.",
              icon: "ri-lightbulb-flash-line",
            },
          ].map((item) => (
            <div
              key={item.title}
              className="p-5 md:p-6 bg-background-100 rounded-xl hover:bg-background-200/70 transition-colors group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3">
          {trustPoints.slice(0, 8).map((point) => (
            <div
              key={point}
              className="flex items-center gap-2 px-3 py-2 bg-background-100 rounded-lg"
            >
              <i className="ri-check-line text-primary-500 text-sm"></i>
              <span className="text-xs text-foreground-700 whitespace-nowrap">{point}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}